import { createContext, ReactNode, useState } from 'react'

import type { DashboardItem } from 'features/dashboard'

type DashboardContextProviderProps = {
	children: ReactNode
}

type DashboardContextProps = {
	dashboard: DashboardItem | null
	setDashboard: (data: DashboardItem | null) => void
}

export const DashboardContext = createContext<DashboardContextProps | null>(null)

export const DashboardContextProvider = ({ children }: DashboardContextProviderProps) => {
	const [dashboard, setDashboard] = useState<DashboardItem | null>(null)

	const value = {
		dashboard,
		setDashboard
	}

	return <DashboardContext.Provider value={value}>{children}</DashboardContext.Provider>
}
